import { useCollaboratorDialog } from '@/contexts/CollaboratorDialogContext';
import { CollaboratorDialog } from '@/components/collaborations/CollaboratorDialog';
import { useBrandManager } from '@/contexts/BrandProvider';
import { useCollaborators } from '@/hooks/useCollaborators';

export const GlobalCollaboratorDialog = () => {
  const { isOpen, closeDialog, editingCollaborator } = useCollaboratorDialog();
  const { currentBrand } = useBrandManager();
  const { createCollaborator, updateCollaborator } = useCollaborators(currentBrand?.id || null);

  const handleSubmit = async (data: any) => {
    if (editingCollaborator) {
      await updateCollaborator({ id: editingCollaborator.id, ...data });
      closeDialog();
    } else {
      await createCollaborator(data);
      closeDialog();
    }
  };

  return (
    <CollaboratorDialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          closeDialog();
        }
      }}
      onSubmit={handleSubmit}
      initialData={editingCollaborator}
    />
  );
};
